/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import FormattedList from 'I18n/components/FormattedList';
import { useEffect, useState } from 'react';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message

import { atomToPromise } from 'customer-data-filters-ui/utils/atomToPromise';
import QuickFiltersTags from './QuickFiltersTags';
import { QuickFiltersValueDisplayUses } from '../../types/quickFilters/QuickFiltersValueDisplayUses';
import { jsx as _jsx } from "react/jsx-runtime";
const valueToTags = value => {
  return value.toArray().map(item => ({
    label: item,
    value: item
  }));
};
const findEnumOption = (optionValue, options) => {
  if (options && typeof options.find === 'function') {
    return options.find(opt => opt.value === optionValue);
  }
  return undefined;
};
const QuickFiltersReferenceEnumValueDisplay = props => {
  const {
    condition,
    resolver,
    specialOptions,
    onValueDelete,
    use
  } = props;
  const [tags, setTags] = useState(valueToTags(condition.value));
  const isReferenceResolver = resolver && resolver.byId;
  const isReferenceResolverLite = resolver && resolver.api && resolver.api.byId;
  useEffect(() => {
    if (isReferenceResolver || isReferenceResolverLite) {
      Promise.all(condition.value.toArray().map(id => {
        const specialOption = findEnumOption(id, specialOptions);
        if (specialOption) {
          return Promise.resolve(specialOption);
        }
        if (isReferenceResolverLite) {
          return resolver.api.byId(id);
        }
        return atomToPromise(resolver.byId(id));
      })).then(results => {
        const resolvedTags = results.map((option, index) => {
          if (option) {
            return {
              value: condition.value.get(index),
              label: option.label
            };
          }
          return {
            value: condition.value.get(index),
            label: condition.value.get(index)
          };
        });
        setTags(resolvedTags);
      });
    }
  }, [condition, isReferenceResolver, isReferenceResolverLite, resolver, specialOptions]);
  if (use === QuickFiltersValueDisplayUses.STRING) {
    return /*#__PURE__*/_jsx(FormattedList, {
      exclusive: true,
      children: tags.map(({
        label
      }) => /*#__PURE__*/_jsx("span", {
        children: label
      }, `quick-filter-reference-enum-${label}`))
    });
  }
  return /*#__PURE__*/_jsx(QuickFiltersTags, {
    tags: tags,
    onTagClose: onValueDelete
  });
};
export default QuickFiltersReferenceEnumValueDisplay;